import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNDrug } from 'src/app/models/cndrug';
import { CNDrugIngredient } from 'src/app/models/cndrugingredient';
import { CNDrugPackage } from 'src/app/models/cndrugpackage';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { DrugNotificationType, DrugNotificationService } from 'src/app/services/drug-notification.service';
import { DrugService } from 'src/app/services/drug.service';

@ManageType('DrugEntryComponent')
@Component({
  selector: 'app-drug-entry',
  templateUrl: './drug-entry.component.html',
  styleUrls: ['./drug-entry.component.scss']
})
export class DrugEntryComponent implements OnInit {

  @Input() drug: CNDrug | CNDrugIngredient;
  @Output() selected: EventEmitter<[CNDrug, CNDrugPackage]> = new EventEmitter();
  packages: CNDrugPackage[];
  public expanded = false;

  constructor(private notification: DrugNotificationService, private drugs: DrugService) { }

  ngOnInit(): void {
  }

  expand(): void {
    if (!this.expanded) {
      // Get all drug packages
      this.drugs.packages(this.drug).subscribe(packages => {
        this.packages = packages;
        this.expanded = !this.expanded;
      });
    } else {
      this.expanded = false;
    }
  }

  selectPackage(drugpackage: CNDrugPackage) {
    this.selected.emit([this.drug, drugpackage]);
  }
}
